import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import Background from 'components/common/Background';
import corner4 from 'assets/img/illustrations/corner-4.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Input from 'components/common/Input';
/* const options = [
 {
  id: 'hjy76g7b656vrf5',
  value:
   'Presentar a la administración del proyecto la documentación necesaria para la firma del acta de separación y copia del volante del pago de separación en un plazo máximo de ocho (8) días, pasada esta fecha, la administración del proyecto no tiene ninguna responsabilidad por la reserva del inmueble y esta queda en libertad de venderlo a otra persona.'
 },
 {
  id: 'dsglhsd8453kk44ssd4',
  value:
   'Son ARRAS: En caso de desistimiento o incumplimiento unilateral de cualquiera de las dos (2) partes sobre las condiciones exigidas en este documento, si es el comprador pagara la suma dada antes de firmar la promesa de compra venta y si es el vendedor, devolverá la totalidad de los pagos recibidos con un interés equivalente al DTF.'
 }
]; */

const Requests = ({ watch, setValue, register, errors }) => {
 return (
  <Card className="mb-3">
   <Background
    image={corner4}
    className="bg-card"
    style={{
     borderTopRightRadius: '0.375rem',
     borderBottomRightRadius: '0.375rem'
    }}
   />
   <Card.Body className="fs--1">
    <div className="mb-3">
     <h5 className="mb-0 text-primary position-relative">
      <FontAwesomeIcon icon="file" />
      <span className="pe-3 ms-1">Condiciones</span>
      <span className="border position-absolute top-50 translate-middle-y w-100 start-0 z-index--1"></span>
     </h5>
     <p className="mb-0">
      Las aclaraciones en la separación son importantes en acuerdos de compraventa de bienes. Detallan términos y condiciones
      específicos acordados por las partes.
     </p>
    </div>
    <Input
     type="list"
     name="request"
     errors={errors}
     placeholder="Nueva condicion"
     options={[...(watch()?.requests || [])]}
     formGroupProps={{
      className: 'flex-fill mb-1'
     }}
     formControlProps={{
      rows: 2,
      size: 'sm',
      className: 'pe-6',
      style: { maxHeight: 300 },
      onChange: items => setValue('requests', items.length ? items : []),
      register: register('requests', {
       required: true,
       validate: value => value.length || 'Debe establecer al menos una condicion'
      })
     }}
    />
   </Card.Body>
  </Card>
 );
};

Requests.propTypes = { watch: PropTypes.func, setValue: PropTypes.func, register: PropTypes.func, errors: PropTypes.object };

export default Requests;
